module.exports = __webpack_public_path__ + "img/zanwugengduo.c43f0685.png";